import React from 'react';
import { hydrate } from 'react-dom';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './app';
import reportWebVitals from './reportWebVitals';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { DASHBOARD_ROUTE } from '@alpha-prep/dashboard';
import { DIAGNOSTIC_ROUTE } from '@alpha-prep/dashboard-diagnostic';
import EagleAIStandalonePage from './components/EagleAIStandalonePage';
import { Provider } from 'react-redux';
import { store } from '@alpha-prep/redux-state';
import { MathJaxContext } from 'better-react-mathjax';

// declare global {
//   interface Window {
//       MathJax: any;
//   }
// }

// Create modified dashboard routes with EagleAIChatbox
// const modifiedDashboardRoutes = DASHBOARD_ROUTE.map((route) => ({
// 	...route,
// 	element: React.cloneElement(route.element as React.ReactElement, { EagleAIChatbox }),
// }));

const router = createBrowserRouter([
	{
		path: '/',
		element: <App />,
		children: [
			{
				path: '',
				children: [...DASHBOARD_ROUTE],
			},
			{
				path: 'alpha-ai',
				element: <EagleAIStandalonePage />,
			},
			{
				path: 'diagnostics',
				children: [...DIAGNOSTIC_ROUTE],
			},
		],
	},
]);

const AppElement = () => {
	// useEffect(() => {
	//   if (typeof window?.MathJax !== "undefined") {
	//     window.MathJax.typeset()
	//   }
	// }, [])
	// localStorage.setItem('api-path', 'https://api.mvpdev.alphaprep.com/');
	const config = {
		loader: { load: ['input/asciimath'] },
	};
	return (
		<React.StrictMode>
			<MathJaxContext config={config}>
				<Provider store={store}>
					<RouterProvider router={router} />
				</Provider>
			</MathJaxContext>
		</React.StrictMode>
	);
};

const rootElement = document.getElementById('root');
if (rootElement && rootElement.hasChildNodes()) {
	hydrate(<AppElement />, rootElement);
} else {
	const root = createRoot(rootElement!); // createRoot(container!) if you use TypeScript
	root.render(<AppElement />);
	// render(<AppElement />, rootElement);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
